export const handleChangeDataModalAddToStock = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_ADD_TO_STOCK', name, value
});